<template>
    <div>
        <navigation-view />
        <sticky-view />

        <section class="m-auto justify-center items-center">
            <div class="w-full mx-auto relative object-cover bg-center bg-no-repeat">
                <img src="../assets/mca/MCA-Computer-Science-and-IT.webp" class="hidden md:block w-full" />
                <img src="../assets/mca/MCA-Computer-Science-and-IT-mob.webp" class="md:hidden w-full object-cover" />
                <div class="max-w-7xl mx-auto flex place-items-center">
                    <div class="absolute text-white text-center lg:text-left mx-auto lg:top-[18%] -top-6">
                        <div class="lg:ml-[11%]">
                            <h1 class="lg:text-4xl lg:pt-2 pt-12 py-2 font-extrabold text-[20px] sm:text-[20px]">
                                MCA in <br />Cloud Computing and Cyber Security
                            </h1>

                            <h2 class="text-white text-lg w-[80%] lg:text-left text-center md:ml-0 m-auto">
                                Transform Organizations, Elevate Careers with our Online MCA in
                                Cloud Computing and Cyber Security
                            </h2>
                        </div>
                        <div class="flex mt-6">
                            <div class="w-full h-[1px] bg-gradient-to-l from-white"></div>
                            <div class="w-full h-[1px] bg-gradient-to-r from-white"></div>
                        </div>
                        <div class="hidden md:block">
                            <div
                                class="flex flex-row text-sm bg-gradient-to-r from-[#7ab422] from-0% via-[#72a821] via-100% to-90% to-[#7ab422] md:text-base lg:ml-32 lg:mr-52 ">
                                <div class="w-[50%] flex justify-center py-2 border-white border-r">
                                    <span class="flex items-center text-base font-bold md:gap-2">
                                        <img src="@/assets/Programpage/banner/banner-3-Years.png" width="25" alt />
                                        2 Years
                                    </span>
                                </div>
                                <div class="w-[50%] flex justify-center py-2 border-white border-r">
                                    <span class="flex items-center text-base font-bold md:gap-2">
                                        <img src="@/assets/Programpage/banner/banner-Total-Credits--140.png" width="30"
                                            alt />
                                        Live Online Classes
                                    </span>
                                </div>
                                <!-- <div class="w-[45%] flex justify-center py-2">
                                    <span class="flex items-center text-base font-bold md:gap-2">
                                        <img src="@/assets/Programpage/banner/credit.webp" width="30" alt />
                                        EMI starting ₹3,210/month*
                                    </span>
                                </div> -->
                            </div>
                        </div>
                        <div
                            class="flex flex-row text-sm bg-gradient-to-r from-[#7ab422] from-0% via-[#72a821] via-100% to-90% to-[#7ab422] md:text-base lg:ml-32 lg:mr-52 md:hidden">
                            <div class="w-[55%] flex justify-center py-2 border-white border-r">
                                <span class="flex items-center text-base font-bold md:gap-2">
                                    <img src="@/assets/Programpage/banner/banner-3-Years.png" width="25" class="mr-1"
                                        alt />
                                    2 Years
                                </span>
                            </div>
                            <div class="w-[70%] flex justify-center py-2 border-white border-r">
                                <span class="flex items-center text-base font-bold md:gap-2">
                                    <img src="@/assets/Programpage/banner/banner-Total-Credits--140.png" class="mr-2"
                                        width="30" alt />
                                    Live Online Classes
                                </span>
                            </div>

                        </div>
                        <div
                            class="flex flex-row text-sm bg-gradient-to-r  border-white border-t from-[#7ab422] from-0% via-[#72a821] via-100% to-90% to-[#7ab422] md:text-base lg:ml-32 lg:mr-52 md:hidden">

                            <!-- <div class="w-[90%] flex justify-center py-2">
                                <span class="flex items-center text-base font-bold md:gap-2">
                                    <img src="@/assets/Programpage/banner/credit.webp" width="30" class="mr-1" alt />
                                    EMI starting ₹3,210/month*
                                </span>
                            </div> -->
                        </div>
                        <div class="flex mb-6">
                            <div class="w-full h-[1px] bg-gradient-to-l from-white"></div>
                            <div class="w-full h-[1px] bg-gradient-to-r from-white"></div>
                        </div>
                        <!-- <div class="lg:ml-[14%]">
                            <h2 class="text-white text-xl lg:text-left text-center md:ml-0 m-auto">
                                Batch start: July 2025
                            </h2>
                        </div> -->
                        <div class="flex gap-4 place-content-center lg:place-content-start mb-4 lg:ml-32">
                            <a @click="handleRedirect"
                                class="px-6 py-2 bg-[#82C8DE] font-bold rounded-lg shadow-xl cursor-pointer">Apply
                                Now</a>

                            <div @click="is_widget = true">
                                <button class="px-6 py-2 bg-[#82C8DE] font-bold rounded-lg shadow-xl" target="_blank">
                                    Download Brochure
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="is_widget" class>
                    <downpopView @closeWidget="is_widget = false" :widget_prop_id="this.brochure_widget" />
                </div>
            </div>
        </section>


        <section class="max-w-7xl mx-auto p-4">
            <h2 class="text-center lg:text-3xl text-[20px] sm:text-[20px] text-gray-700 font-bold lg:p-4 p-1">
                About Specialization - Cloud Computing and Cyber Security
            </h2>

            <!-- <h6
          class="text-center lg:text-xl text-[20px] sm:text-[20px] text-gray-700"
        >International Finance and Accounting</h6>-->
            <div class="text-left text-justify readmore-section p-4">
                <p>
                    The Master of Computer Applications (MCA) in Cloud Computing & Cyber Security is a four-semester,
                    industry-aligned postgraduate program designed to build strong professionals in modern IT
                    infrastructure,
                    cloud platforms, enterprise systems, and cybersecurity operations.
                </p>

                <p class="paragraph hidden">
                    The program blends core computing foundations with hands-on administration, security, automation,
                    and analytics across on-premise, cloud, and hybrid environments.
                    Students gain deep exposure to Linux, Windows Server, Networking, AWS, Microsoft Azure, Cyber
                    Forensics,
                    Ethical Hacking, SIEM, and Cloud Security, supported by real-world use cases and practical labs.
                </p>

                <p class="paragraph hidden">
                    By the final semester, students complete an industry-oriented capstone project,
                    demonstrating end-to-end skills in designing, securing, monitoring, and managing enterprise IT and
                    cloud systems.
                </p>

                <p class="paragraph hidden">
                    This program is structured to prepare graduates for immediate employability in cloud operations,
                    cybersecurity roles, SOC teams, and infrastructure engineering positions.
                </p>

                <p class="flex align-middle place-content-end gap-2">
                    <button class="readmore-btn text-gray-600">Read More</button>
                    <img src="../assets/program/read-more.png" width="25" alt />
                </p>
            </div>
        </section>

        <section
            class="xl:flex lg:gap-12 max-w-7xl mx-auto p-4 text-center lg:flex-row flex flex-col-reverse xl:text-left">
            <div class="lg:w-1/2">
                <h1 class="lg:text-3xl text-[20px] sm:text-[20px] text-gray-700 font-bold lg:py-6 py-4">
                    Program Highlights
                </h1>
                <div>
                    <ul class="divide-y text-left">
                        <li class="flex gap-4 p-2">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Strong Core
                                        + Advanced Specialization:</p>
                                </li>
                                <li class="list-disc ml-8">Programming foundations (C, Python)</li>
                                <li class="list-disc ml-8">Operating Systems, Networking, Linux, Windows Server</li>
                                <li class="list-disc ml-8">Advanced Cloud & Cyber Security subjects</li>
                            </ul>
                        </li>

                        <li class="flex gap-4 p-2 mt-1">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Cloud
                                        Platforms in Depth:</p>
                                </li>
                                <li class="list-disc ml-8">AWS Cloud Administration & Networking</li>
                                <li class="list-disc ml-8">Microsoft Azure & Hybrid Cloud Management</li>
                                <li class="list-disc ml-8">Enterprise virtualization, storage, backup, and Disaster
                                    Recovery</li>
                            </ul>
                        </li>

                        <li class="flex gap-4 p-2 mt-1">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Practical &
                                        Application-Oriented Learning</p>
                                </li>
                                <li class="list-disc ml-8">Case studies on Indian & global governance</li>
                                <li class="list-disc ml-8">Policy briefs and project work</li>
                                <li class="list-disc ml-8">Field exposure and institutional analysis</li>
                                <li class="list-disc ml-8">Research-based assignments</li>
                            </ul>
                        </li>

                        <li class="flex gap-4 p-2 mt-1">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Cyber
                                        Security Focus:</p>
                                </li>
                                <li class="list-disc ml-8">Ethical Hacking & Penetration Testing</li>
                                <li class="list-disc ml-8">Cyber Forensics & Incident Analysis</li>
                                <li class="list-disc ml-8">SIEM & SOC Operations using Splunk</li>
                            </ul>
                        </li>

                        <li class="flex gap-4 p-2 mt-1">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Hands-On,
                                        Practical Orientation:</p>
                                </li>
                                <li class="list-disc ml-8">Real-world labs on Linux, Windows Server, AWS, Azure</li>
                                <li class="list-disc ml-8">Security investigations, log analysis, and incident response
                                </li>
                                <li class="list-disc ml-8">Capstone project in Semester IV</li>
                            </ul>
                        </li>

                        <li class="flex gap-4 p-2 mt-1">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Enterprise
                                        & Industry Relevance:</p>
                                </li>
                                <li class="list-disc ml-8">Hybrid IT infrastructure exposure</li>
                                <li class="list-disc ml-8">SOC simulations, threat detection, and compliance analytics
                                </li>
                                <li class="list-disc ml-8">Aligned to current enterprise job roles, not outdated theory
                                </li>
                            </ul>
                        </li>

                        <li class="flex gap-4 p-2 mt-1">
                            <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                            <ul class="pl-2">
                                <li>
                                    <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">
                                        Career-Ready Curriculum:</p>
                                </li>
                                <li class="list-disc ml-8">Focus on administration, operations, and security roles</li>
                                <li class="list-disc ml-8"> Skills mapped to real IT teams, not just certifications</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="border-r m-4 hidden lg:block"></div>
            <div class="lg:w-1/2">
                <h2 class="lg:text-3xl text-[20px] sm:text-[20px] text-gray-700 font-bold lg:py-6 py-4">
                    Eligibility
                </h2>
                <ul class="divide-y text-left">
                    <li class="flex gap-4 p-2">
                        <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                        <p>
                            Pass in an Undergraduate (Bachelor) Program of a minimum duration of three (3) years in any
                            stream from a UGC Recognized University,
                            with a minimum aggregate of 50% or an equivalent letter/numerical grade. A relaxation of 5%
                            shall be given to SC/ST candidates.
                            <br /><br />
                            Students who are in the final semester of their Bachelor’s degree may apply provisionally.
                            Final admission is granted only after successful completion of the qualifying degree and
                            submission of all required documents.
                        </p>
                    </li>
                </ul>
            </div>
        </section>

        <section class="max-w-7xl mx-auto p-2 text-center justify-center object-cover lg:flex-row flex">
            <div class="px-4 lg:py-4 py-1 gap-6 justify-between">
                <h2 class="lg:text-3xl text-[20px] sm:text-[20px] text-gray-700 text-center font-bold lg:py-6 py-4">
                    Career Opportunities
                </h2>

                <div class="text-left text-justify p-4">
                    <p>Graduates of the MCA (Cloud Computing & Cyber Security) program can pursue roles such as:</p>
                </div>

                <div class="px-4 lg:py-8 py-1 gap-6 flex flex-col lg:flex-row mx-0 justify-center">
                    <div class="flex lg:w-[50%] w-full">
                        <ul class="divide-y text-left">
                            <li class="flex gap-4 p-2 pb-6">
                                <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                                <ul class="pl-2">
                                    <li>
                                        <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Cloud &
                                            Infrastructure Roles:</p>
                                    </li>
                                    <li class="list-disc ml-8">Cloud Administrator (AWS / Azure)</li>
                                    <li class="list-disc ml-8">Cloud Support Engineer</li>
                                    <li class="list-disc ml-8">Systems Administrator (Linux / Windows Server)</li>
                                    <li class="list-disc ml-8">Infrastructure Engineer</li>
                                    <li class="list-disc ml-8">Hybrid Cloud Engineer</li>
                                </ul>
                            </li>

                            <li class="flex gap-4 p-2 pt-8">
                                <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                                <ul class="pl-2">
                                    <li>
                                        <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">Cyber
                                            Security Roles:</p>
                                    </li>
                                    <li class="list-disc ml-8">SOC Analyst (L1 / L2)</li>
                                    <li class="list-disc ml-8">Ethical Hacker / Penetration Tester</li>
                                    <li class="list-disc ml-8">Incident Response Analyst</li>
                                    <li class="list-disc ml-8">Cyber Forensics Analyst</li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div class="flex lg:w-[50%] w-full">
                        <ul class="divide-y text-left">
                            <li class="flex gap-4 p-2 mt-1 h-[180px]">
                                <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                                <ul class="pl-2">
                                    <li>
                                        <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">
                                            Enterprise IT & Operations:</p>
                                    </li>
                                    <li class="list-disc ml-8">Network Administrator</li>
                                    <li class="list-disc ml-8">IT Operations Engineer</li>
                                    <li class="list-disc ml-8">Security Operations Engineer</li>
                                    <li class="list-disc ml-8">Cloud Security Analyst</li>
                                </ul>
                            </li>
                            <li class="flex gap-4 p-2 pt-8">
                                <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
                                <ul class="pl-2">
                                    <li>
                                        <p class="text-[16px] lg:text-[19px] text-gray-700 font-bold text-start">
                                            Advanced Growth Paths (with experience):</p>
                                    </li>
                                    <li class="list-disc ml-8">Cloud Security Architect</li>
                                    <li class="list-disc ml-8">SOC Lead / Blue Team Specialist</li>
                                    <li class="list-disc ml-8">Security Consultant</li>
                                    <li class="list-disc ml-8"> Devops Engineer</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="p-4 lg:py-8 py-2 max-w-7xl mx-auto">
            <h2 class="lg:text-3xl text-[20px] text-gray-700 font-bold text-center lg:p-4">
                Course Matrix
            </h2>

            <div class="lg:flex lg:gap-4 flex-wrap justify-center">
                <div v-for="semester in semesters" :key="semester.id">
                    <!-- Accordion Header -->
                    <h2 class="pt-4 moreBox1">
                        <button @click="toggleSemester(semester.id)"
                            class="flex items-center justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white">
                            <span class="text-black">
                                {{ semester.title }} ({{ semester.credits }} Credits)
                            </span>

                            <img src="../assets/about/read-more.png" width="20" alt />
                        </button>
                    </h2>

                    <!-- Accordion Body -->
                    <div v-show="activeSemester === semester.id">
                        <div
                            class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                            <ul class="divide-y">
                                <li v-for="(course, index) in semester.courses" :key="index"
                                    class="flex gap-4 p-2 items-center">
                                    <img src="../assets/Programpage/Eligibility/blue_bullet.webp" class="h-5" alt />
                                    <p>{{ course }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="max-w-7xl mx-auto lg:py-6 py-2">
            <h1 class="text-3xl text-gray-700 text-center font-bold p-2 lg:text-3xl text-[20px] sm:text-[20px]">
                Fee Structure
            </h1>
            <div class="mx-auto bg-white rounded-lg shadow-lg text-center p-2 lg:w-full w-[90%] sm:w-[90%]">
                <div class="m-4">
                    <!-- Tab content -->
                    <div class="tabcontent flex flex-col lg:flex-row">
                        <div class="w-full">
                            <h1
                                class="tablinks align-bottom rounded-t-lg py-4 mt-4 px-4 mx-1 text-white font-semibold text-center bg-[#9D9B9C]">
                                Domestic fee structure
                            </h1>
                            <table class="w-full border-4 border-white">
                                <tr class="bg-[#94C34D] text-white h-16">
                                    <th class="border-4 border-white">Yearly Fee Plan</th>
                                    <th class="border-4 border-white">Total Fee Plan</th>
                                </tr>
                                <tr class="bg-[#BDE6F7] h-10 text-center">
                                    <td class="border-4 border-white">₹ 25,000</td>
                                    <td class="border-4 border-white">₹ 50,000</td>
                                </tr>
                            </table>
                        </div>
                        <div class="w-full">
                            <h1
                                class="tablinks align-bottom rounded-t-lg py-4 mt-4 px-4 mx-1 text-white font-semibold text-center bg-[#9D9B9C]">
                                International fee structure
                            </h1>
                            <table class="w-full border-4 border-white">
                                <tr class="bg-[#94C34D] text-white h-16">
                                    <!-- <th class="border-4 border-white">Semester x 6</th> -->
                                    <th class="border-4 border-white">Yearly Fee Plan</th>
                                    <th class="border-4 border-white">Total Fee Plan</th>
                                </tr>
                                <tr class="bg-[#BDE6F7] h-10 text-center">
                                    <td class="border-4 border-white">$ 417</td>
                                    <td class="border-4 border-white">$ 833</td>
                                    <!-- <td class="border-4 border-white">$ 2,400</td> -->
                                </tr>
                            </table>
                        </div>
                    </div>
                    <span class="text-sm"><span class="text-red-600">Note:</span> Applicable examination fee per year:
                        <br>
                        For Indian students: ₹3,000 <br>
                        For SAARC students: ₹3,000 <br>
                        For International students: $50</span>
                </div>
            </div>
        </section>
        <section v-if="is_widget">
            <div class="fixed inset-0 z-50 overflow-y-auto w-full bg-black bg-opacity-60">
                <div class="flex items-center justify-center min-h-screen">
                    <div class="relative bg-white rounded-lg h-[300px] w-[450px] z-60 p-4">
                        <div class="npf_wgts" data-height="344px" :data-w="this.widget_id2"></div>
                        <button @click="is_widget = false"
                            class="absolute top-0 right-1 bg-white rounded-full p-1 z-50">
                            <svg class="h-6 w-6 fill-current text-gray-700 hover:text-gray-600 transition duration-150 ease-in-out"
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M10 8.586l4.95-4.95 1.414 1.414L11.414 10l4.95 4.95-1.414 1.414L10 11.414l-4.95 4.95-1.414-1.414L8.586 10 3.636 5.05l1.414-1.414L10 8.586z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>

                        <div class>
                            <div class="flex items-center justify-center">
                                <div class="relative bg-white rounded-lg shadow-sm">
                                    <h4 class="font-bold text-lg px-2 py-2">
                                        Download Brochure
                                        <br />
                                    </h4>
                                    <div>
                                        <form class="space-y-3 p-4 font-normal" @submit.prevent="brochureSubmit">
                                            <input type="text" placeholder="Enter Name *" id="FirstName"
                                                class="p-1 rounded-sm w-full border-gray-300"
                                                v-model="formInfo.firstName" />
                                            <input type="email" placeholder="Enter Email Address *" id="EmailAddress"
                                                class="p-1 rounded-sm w-full border-gray-300"
                                                v-model="formInfo.email" />

                                            <input type="tel" placeholder="Enter Mobile Number *" id="phone"
                                                maxlength="10"
                                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                                class="p-1 rounded-sm w-full border-gray-300" required />

                                            <select name="mx_Program" id value="mx_Program"
                                                aria-placeholder="Select Program"
                                                class="p-1 rounded-sm w-full border-gray-300 text-base hidden" required>
                                                <option value="BCA">MCA</option>
                                            </select>
                                            <select name="mx_Elective" id="mx_Elective"
                                                aria-placeholder="Select Elective"
                                                class="p-1 rounded-sm w-full border-gray-300 text-base hidden">
                                                <option value="none">Select Specialization *</option>
                                                <option value="Computer Science and Information Technology">
                                                    Computer Science and Information Technology
                                                </option>
                                            </select>

                                            <button type="submit"
                                                class="w-full text-white bg-[#9C9B9D] hover:bg-[#94C34D] rounded-lg px-4 py-2 text-center">
                                                Download Brochure &#10148;
                                            </button>

                                            <!-- <button
                            type="submit"
                            class="w-full text-white bg-[#9C9B9D] hover:bg-[#94C34D] rounded-lg px-4 py-2 text-center"
                          >
                            Download Brochure &#10148;
                          </button>-->
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <faq-view />
        <footer-view />
        <div v-if="is_widget">
            <ElectiveBrochure
                brochureUrl="https://yenepoya-online-bucket-v2.s3.ap-south-1.amazonaws.com/mca-in-cloud-computing-cyber-security.pdf"
                @closeModel="is_widget = false" />
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import FaqView from "../components/MCACloudFaq.vue";
import FooterView from "../components/FooterView.vue";
import NavigationView from "../components/NavigationView.vue";
import StickyView from "../components/StickyView.vue";
// import DownpopView from "@/components/DownpopView.vue";
import { useHead } from "@vueuse/head";
import ElectiveBrochure from "../components/ElectiveBrochureView.vue";
export default {
    components: { FaqView, StickyView, FooterView, NavigationView, ElectiveBrochure },
    data() {
        return {
            is_widget: false,
            showMenu: false,
            formInfo: {
                firstName: "",
                email: "",
                phone: "",
            },
            activeSemester: null,
            semesters: [
                {
                    id: 1,
                    title: "Semester 1",
                    credits: 20,
                    courses: [
                        "Fundamentals of C Programming",
                        "Probability and Statistics",
                        "Generative AI for App Development",
                        "Database Management Systems",
                        "HTML, CSS, and JavaScript"
                    ]
                },
                {
                    id: 2,
                    title: "Semester 2",
                    credits: 20,
                    courses: [
                        "Operating Systems",
                        "Python Programming",
                        "Data Structures and Algorithms",
                        "Cloud Computing Foundations",
                        "UI Development Using React"
                    ]
                }, {
                    id: 3,
                    title: "Semester 3",
                    credits: 20,
                    courses: [
                        "Software Testing and Quality Assurance",
                        "Web Application Development and Deployment",
                        "Machine Learning for Developers",
                        "Java Programming",
                        "Advanced Database Management Systems"
                    ]
                },
                {
                    id: 4,
                    title: "Semester 4",
                    credits: 20,
                    courses: ["Project"]
                }
            ]
        };
    },
    // created(){
    //   setTimeout(()=>{
    //     this.is_widget = true
    //   },2000)
    // },

    mounted() {
        $(".readmore-btn").on("click", function (e) {
            var target = $(e.target).parents(".readmore-section");
            var paragraph = target.find(".paragraph");

            if (paragraph.hasClass("hidden")) {
                paragraph.removeClass("hidden");
                $(this).text("Read Less");
            } else {
                paragraph.addClass("hidden");
                $(this).text("Read More");
            }
        });

        $(document).ready(function () {
            $(".moreBox1").slice(0, 3).show();
            if ($(".accordion-item:hidden").length != 0) {
                $("#loadMore1").show();
            }
            $("#loadMore1").on("click", function (e) {
                e.preventDefault();
                $(".moreBox1:hidden").slice(0, 4).slideDown();
                if ($(".moreBox1:hidden").length == 0) {
                    $("#loadMore1").fadeOut("slow");
                }
            });
        });
    },

    setup() {
        useHead({
            // Can be static or computed
            title: "Online MCA in Computer Science and Information Technology | Yenepoya Online",
            meta: [
                {
                    name: `description`,
                    content:
                        "Experience growth and success in HR Domain with an Online MCA in Computer Science and Information Technology from Yenepoya Online. Start your journey to success",
                },
            ],

            link: [
                {
                    rel: "canonical",
                    href: "https://onlineyenepoya.com/programs/online-mca-computer-science-and-it",
                },
            ],
        });
    },
    methods: {
        handleRedirect() {
            const currentUrl = window.location.href;
            const targetUrlWithSrc = "https://gcc.onlineyenepoya.com/apply-now.php";
            const targetUrlWithoutSrc = "https://apply.onlineyenepoya.com/";

            const finalUrl = currentUrl.includes("src=landing") ? targetUrlWithSrc : targetUrlWithoutSrc;

            window.open(finalUrl, "_blank", "noopener,noreferrer");
        },
        toggleSemester(id) {
            this.activeSemester = this.activeSemester === id ? null : id;
        },
    }
};
</script>

<style></style>